import React, {useEffect, useState} from "react";
import {Player} from "@lottiefiles/react-lottie-player";

const GameLoadingScreen = ({thumbnail}) => {
    const theme = process.env.REACT_APP_THEME || "dark";
    const isLight = theme === "light";
    const backgroundColor = isLight ? "bg-[#f5f5f5]" : "bg-[#0f1025]";
    const textColor = isLight ? "text-[#0f1025]" : "text-[#f5f5f5]";
    const barBgColor = isLight ? "bg-gray-300" : "bg-gray-700";
    const barFillColor = isLight ? "bg-black" : "bg-white";
    const brandLogo = isLight ? "/logo-black.png" : "/logo-white.png";


    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const duration = 1800; // 2 seconds
        const start = performance.now();

        const easeInCubic = (t) => t * t * t;

        const updateProgress = (timestamp) => {
            const elapsed = timestamp - start;
            const t = Math.min(elapsed / duration, 1); // Clamp to [0,1]
            const eased = easeInCubic(t);
            const percent = Math.round(eased * 100);
            setProgress(percent);

            if (t < 1) {
                requestAnimationFrame(updateProgress);
            } else {
                setProgress(100); // Ensure it ends exactly at 100%
            }
        };

        requestAnimationFrame(updateProgress);
    }, []);
    return (
        <div className={`w-screen h-screen flex flex-col ${backgroundColor}`}>
            <style>
                {`
                    @keyframes loaderEaseIn {
                        0% { width: 0%; }
                        100% { width: 100%; }
                    }

                    .progress-bar {
                        animation: loaderEaseIn 1.8s ease-in forwards;
                    }
                `}
            </style>
            <div className="flex-grow flex flex-col items-center justify-center">
                <div className="w-[100px] md:w-[150px] h-auto mb-8 flex justify-center items-center">

                    {process.env.REACT_APP_CUSTOM_THUMBNAIL_ON_LOADING_SCREEN ? (
                        <img
                            src={process.env.REACT_APP_CUSTOM_THUMBNAIL_ON_LOADING_SCREEN }
                            className={`w-[200px] rounded-xl ${backgroundColor}`}
                        />
                    ) : process.env.REACT_APP_SHOW_GAME_THUMBNAIL_ON_LOADING_SCREEN === "true" ? (
                        <img
                            src={thumbnail}
                            className={`w-[100px] md:w-[150px] h-[100px] md:h-[150px] rounded-xl ${backgroundColor}`}
                        />
                    ) : (
                        <Player
                            className="mx-auto"
                            src="/animation_llkrpnwl.json"
                            loop
                            autoplay
                            style={{width: '200px', height: '200px'}}
                        />
                    )}
                </div>


                <div className={`w-1/3 max-w-[300px] text-center text-sm ${textColor}`}>
                    <div className={`h-1 w-full ${barBgColor} rounded overflow-hidden`}>
                        <div className={`h-full ${barFillColor} rounded progress-bar`}/>
                    </div>
                    <p className={`mt-2 text-lg`}>Loading Game</p>
                    <p className={`text-md opacity-80`}>{progress}%</p>
                </div>
            </div>

            <footer className="mb-6 text-center mx-auto">
                {process.env.REACT_APP_BRAND_LOGO === "TP" && process.env.REACT_APP_SHOW_TIMEPASS_LOGO_ON_LOADER_SCREEN !== "false" && (
                    <a
                        href="https://timepass.app/yLpY/32natroq"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src={brandLogo}
                            alt="Brand Logo"
                            className="h-8 md:h-10 w-auto object-contain rounded-xl"
                        />
                    </a>
                )}
            </footer>
        </div>
    );
};

export default GameLoadingScreen;
